import { SagaIterator } from "redux-saga";
import {call, Effect, put, select} from "redux-saga/effects";

import {fetchTranslations} from "@montana/services/content";
import {IStoreState} from "@montana/store/store";

import {fetchTranslationsFailure, fetchTranslationsSuccess} from "./translations.actions";
import {ITranslationsContainerState} from "./translations";
import {makeGetTranslation} from "./translations.container";
import {ITranslations} from "@montana/models/generated/cms.interface";
import {connectServiceFunctions, selectCurrentUrlLocale} from "../base/base.sagas";

export function* getTranslations(): SagaIterator {
    try {
        const language: string = yield selectCurrentUrlLocale();
        const [cFetchTranslations]: any[] = yield connectServiceFunctions(fetchTranslations);
        const response: Response = yield call(cFetchTranslations, language);
        const { json, ok } = response;

        if (!ok) {
            throw new Error();
        }

        const translations: ITranslations = yield call(json.bind(response));
        return yield put(fetchTranslationsSuccess(translations));

    } catch (e) {
        // TODO: Display notification...
        // eslint-disable-next-line no-console
        console.error("Could not get translations.", e);
    }

    return put(fetchTranslationsFailure());
}

// eslint-disable-next-line max-len
export function* getTranslation(translationSelector: (translations: ITranslationsContainerState) => string, defaultValue: string): IterableIterator<Effect> {
    const translations: ITranslationsContainerState = (yield select((state: IStoreState): ITranslationsContainerState => state.translations)) as unknown as ITranslationsContainerState;

    return makeGetTranslation(translations)(translationSelector, defaultValue);
}
